var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.MODAL_STATE)?_c('div',{staticClass:"modal__wrapper"},[_c('transition',{attrs:{"name":"show_modal"}},[(_vm.MODAL_ID_STATE === 1)?_c('Auth'):_vm._e(),(_vm.MODAL_ID_STATE === 2)?_c('Cash'):_vm._e(),(_vm.MODAL_ID_STATE === 3)?_c('ResetPass'):_vm._e(),(_vm.MODAL_ID_STATE === 4)?_c('AddChild'):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }